module.exports = __webpack_public_path__ + "img/tpc-4.e3a48dfb.webp";